import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { SupplierManagementPage } from '@/areas/suppliers/Suppliers/SupplierManagementPage';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/suppliers/')({
    staticData: { access: { permissions: ['view:supplier'] }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <SupplierManagementPage />;
}
